import { TextInput } from '@mantine/core';

export default TextInput.extend({
  defaultProps: {
    size: 'md',
  },
});
